import React from 'react';
import Icon from '../icons/Icon';

const ActionsBarHeader = () => {
    const renderPhoneNumber = () => {
        return (
            <div>
                <div className="app__header__actions__phone-number app__header__actions__phone-number--mobile">
                    <a href="tel:03300388543">
                        <Icon icon="phone" size="25px" style={{ fill: '#FFFFFF' }} />
                    </a>
                </div>
                <div className="app__header__actions__phone-number">
                    <a href="tel:033003885433">
                        <span className="app__header__actions__phone-number__icon">
                            <Icon icon="phone" size="22px" style={{ fill: '#FFFFFF' }} />
                        </span>
                        <span className="app__header__actions__phone-number__number">
                            0330 038 8543
                        </span>
                    </a>
                </div>
            </div>
        );
    };

    return <div className="app__header__actions">{renderPhoneNumber()}</div>;
};

export default ActionsBarHeader;
